module.exports = __webpack_public_path__ + "60a104f47b0ac0cb72445ddb38116a1c.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/saaspass-vpn/configuration/configuration.html
// module id = 1746
// module chunks = 0